module.exports = __webpack_public_path__ + "static/media/1.b1313fdf.jpg";